import { combineReducers } from "redux";
import membershipReducer from './membershipReducer';
import alertReducer from './alertReducer';

export default combineReducers({
  membership: membershipReducer,
  alert: alertReducer,
});
